/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Faq_TitleInputs */

const en_cp_faq_title = /** @type {(inputs: Cp_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What lecturers usually ask`)
};

const id_cp_faq_title = /** @type {(inputs: Cp_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yang sering ditanyakan dosen`)
};

/**
* | output |
* | --- |
* | "What lecturers usually ask" |
*
* @param {Cp_Faq_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_faq_title = /** @type {((inputs?: Cp_Faq_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Faq_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_faq_title(inputs)
	return en_cp_faq_title(inputs)
});